import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ContentCreate from '@material-ui/icons/Create';
import { Button } from 'react-admin';
import omit from 'lodash/omit';

const EditButtonWithOnClick = ({
  basePath = '',
  label = 'ra.action.edit',
  record = {},
  icon = <ContentCreate />,
  onClick,
  headerClassName,
  ...rest
}) => (
  <Button
    disableFocusRipple
    label={label}
    onClick={() => onClick(record, basePath)}
    id="edit-button"
    {...omit(rest, ['cellClassName'])}
  >
    {icon}
  </Button>
);

EditButtonWithOnClick.propTypes = {
  basePath: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object,
  label: PropTypes.string,
  record: PropTypes.object,
  icon: PropTypes.element,
  onClick: PropTypes.func
};

export default memo(
  EditButtonWithOnClick,
  (props, nextProps) =>
    props.translate !== nextProps.translate ||
    (props.record &&
      nextProps.record &&
      props.record.id !== nextProps.record.id) ||
    props.basePath !== nextProps.basePath ||
    (props.record == null && nextProps.record != null)
);
